import {InfoEntry, TFaqSection, TMetaData} from '.'

const MetaData: TMetaData = {
  title: 'டவுன்லோடு செய்யாமல் இலவசமாக ஆன்லைன் கேம்ஸ் விளையாட | Gamezop',
  desc: 'டவுன்லோடு செய்யாமல் ப்ளே ஆன்லைன் கேம்ஸ் இலவசமாக Gamezop-இல் விளையாடுங்கள். 200+ ப்ரீ கேம்ஸ் உங்களுக்காக, அதில் ஆக்ஷன், அட்வென்ச்சர், ஆர்கேட், பஸ்ஸில், ரேசிங் மற்றும் பல உள்ளன. இப்போது விளையாடு',
}

const InfoData: InfoEntry[] = [
  {
    tag: 'h1',
    title: 'டவுன்லோடு செய்யாமல் இலவசமாக ஆன்லைன் கேம்ஸ் விளையாட',
    body: {
      text: [
        `Gamezop இல் பதிவிறக்கம் செய்யாமல் இலவசமாக ஆன்லைன் விளையாடுங்கள்!
உங்கள் பிடித்த விளையாட்டை தேர்வு செய்து சில விநாடிகளில் விளையாடத் தொடங்குங்கள். எங்களிடம் 200+ இலவச விளையாட்டுகள் உள்ளன, அவை செயல், சாதனை, பைரட், புதிர், ரேசிங் போன்ற பிரிவுகளில் உள்ளன. மொபைல், PC அல்லது iOS மீது நீங்கள் விளையாடினாலும், Gamezop உங்களுக்கான சிறந்த விளையாட்டுகளை வழங்குகிறது.`,
        `களைப்பு ஏற்படுகிறதா? Gamezop உங்களுக்கு முடிவில்லா பொழுதுபோக்கை தருகிறது. Kingdom Fight, City Cricket, Fruity Fiesta போன்ற விறுவிறுப்பான விளையாட்டுகளை அனுபவிக்கவும். எங்கள் விளையாட்டுகள் குழந்தைகள், பெரியவர்கள் மற்றும் முதியவர்கள் அனைவருக்கும் பொருந்தும்.`,
        `இவைகளை விளையாட நீங்கள் அதிக விலையுள்ள சாதனங்கள் தேவை இல்லை. எங்கள் விளையாட்டுகள் உருவாக்கம் அல்லது பதிவிறக்கம் செய்யாமல் நேரடியாக உலாவி & இணைய இணைப்பு மூலம் இயங்கும். டெஸ்க்டாப், லாப்டாப், Chromebook, ஸ்மார்ட்போன், டேப்லெட் உள்ளிட்ட அனைத்துப் சாதனங்களிலும் விளையாடலாம்.`,
      ],
      list: [],
    },
    links: {
      'Kingdom Fight': {
        type: 'game',
        name: 'Kingdom Fight',
        code: 'SyfxJ3a75Cr',
      },
      'City Cricket': {
        type: 'game',
        name: 'City Cricket',
        code: 'HJP4afkvqJQ',
      },
      'Fruity Fiesta': {
        type: 'game',
        name: 'Fruity Fiesta',
        code: 'mKZZW9NXW',
      },
    },
  },
  {
    tag: 'h2',
    title: 'சிறந்த ப்ரி ஆன்லைன் கேம்ஸ் எவை?',
    body: {
      text: [],
      list: [
        {
          name: 'Bubble Wipeout',
          code: 'H1AN6fkwqJ7',
          type: 'game',
        },
        {
          name: 'Mahjong At Home: Scandinavian Edition',
          code: 'JVhRZNwly',
          type: 'game',
        },
        {
          name: 'Merge Mania',
          code: 'hfPOimYqY',
          type: 'game',
        },
        {
          name: 'Chef Tycoon',
          code: 'xqO4nZ6Kt',
          type: 'game',
        },
        {
          name: 'Cyberfusion',
          code: 'HJXei0j',
          type: 'game',
        },
        {
          name: 'Mafia Billiard Tricks',
          code: 'SkkV6MJD51Q',
          type: 'game',
        },
        {
          name: 'Spider Solitaire',
          code: 'B1MfIa4QCg',
          type: 'game',
        },
        {
          name: 'Basket Champs',
          code: 'S1_V6GyP5ym',
          type: 'game',
        },
        {
          name: 'Algerian Solitaire',
          code: 'rJu76zkD917',
          type: 'game',
        },
        {
          name: 'Dragon Annihilation',
          code: 'PdIZyZNAe',
          type: 'game',
        },
      ],
    },
    initalState: 'initial_open',
  },
  {
    tag: 'h2',
    title: 'நண்பர்களுடன் விளையாட ப்ரி ஆன்லைன் கேம்ஸ் என்னென்ன?',
    body: {
      text: [],
      list: [
        {
          name: 'Ludo with Friends',
          code: 'SkhljT2fdgb',
          type: 'game',
        },
        {
          name: 'ZUNO',
          code: 'ByQxJnp7qRB',
          type: 'game',
        },
        {
          name: 'Tic Tac Toe',
          code: 'H1WmafkP9JQ',
          type: 'game',
        },
        {
          name: 'Ludo Dash',
          code: 'SJRX12TXcRH',
          type: 'game',
        },
      ],
    },
    initalState: 'initial_open',
  },
  {
    tag: 'h2',
    title: 'மிகவும் பிரபலமான ஆன்லைன் கேம்ஸ் ஜானரே எவை?',
    body: {
      text: [],
      list: [
        {
          name: 'க்ரேசி கேம்ஸ்',
          nameEn: 'Crazy games',
          code: '10',
          type: 'tag',
        },
        {
          name: 'போர்டு கேம்ஸ்',
          nameEn: 'Board games',
          code: '11',
          type: 'tag',
        },
        {
          name: 'அட்வென்ச்சர் கேம்ஸ்',
          nameEn: 'Adventure games',
          code: '14',
          type: 'tag',
        },
        {
          name: 'பஸ்ஸில் கேம்ஸ்',
          nameEn: 'Puzzle games',
          code: '8',
          type: 'tag',
        },
        {
          name: 'ஷூட்டிங் கேம்ஸ்',
          nameEn: 'Shooting games',
          code: '2',
          type: 'tag',
        },
      ],
    },
    initalState: 'initial_open',
  },
  {
    tag: 'h2',
    title: 'Gamezop என்றால் என்ன?',
    body: {
      text: [
        `Gamezop ஒரு பிளக்-அன்-ப்ளே கேமிங் ப்ளாட்ஃபார்ம், இது எந்த அப் அல்லது வெப்சைட்-யும் எளிதாக கேஷுவல் கேம்ஸ்களை ஒருங்கிணைத்து, பயனர் ஈர்ப்பை அதிகரிக்க உதவுகிறது. கேமிங் துறைக்கு அப்பாற்பட்ட விதமாக, Gamezop பல தனிப்பட்ட ப்ளாட்ஃபார்ம்-களை இயக்குகிறது: Quizzop இண்டர்ஆக்டிவ் க்விஸ்கள் மற்றும் ட்ரிவியா ஆகியவற்றிற்காக, Astrozop ஜோதிட முன்னறிவிப்புகள் மற்றும் பரிந்துரைகளுக்காக, Criczop நேரடி கிரிக்கெட் ஸ்கோர்கள் மற்றும் புதுப்பிக்கல்களுக்காக, மற்றும் Feedzop தேர்ந்தெடுக்கப்பட்ட செய்தி தொகுப்புகளுக்காக. இவை அனைத்தும் சேர்ந்து, பல்வேறு ஆர்வங்களைக் கொண்ட பயனர்களுக்குப் பொருத்தமான கொண்டென்ட் தீர்வுகளின் பரவலான தொகுப்பை வழங்குகின்றன.`,
        `8,000 க்கும் மேற்பட்ட ஒருங்கிணைப்புகள், 70 க்கும் மேற்பட்ட நாடுகளில், Gamezop மற்றும் அதன் இணை ப்ளாட்ஃபார்ம்-கள் Amazon, Samsung Internet, Snap, Tata Play, AccuWeather, மற்றும் Paytm போன்ற உலகப் பிரசித்தி பெற்ற பிராண்டுகளால் நம்பிக்கைக்குரியதாக உள்ளன. இந்த தீர்வுகள் பயனர் ஈர்ப்பை மட்டுமல்லாமல், புதிய விளம்பர வருவாய் வாய்ப்புகளையும் உருவாக்குகின்றன. ஒருங்கிணைப்பு மிக எளிதானது, மொத்தம் 30 நிமிடங்களில் முடிக்கலாம், மேலும் அப் மற்றும் வெப்சைட்களுக்குப் பயனர்களுக்கு கேம்ஸ், க்விஸ்கள், ஜோதிடம், கிரிக்கெட் மற்றும் செய்திகள் ஆகியவற்றை ஈர்க்கும் வகையில் வழங்க உதவுகின்றன.`,
      ],
      list: [],
    },
    initalState: 'initial_open',
  },
]

const FaqData: TFaqSection = {
  headTag: 'h2',
  headTitle: 'FAQs',
  faqs: [
    {
      tag: 'h3',
      title: 'நான் இலவச கேம்ஸ்-ஐ இன்ஸ்டால் செய்யாமல் விளையாட முடியுமா?',
      body: ['ஆமாம், நீங்கள் இலவச கேம்ஸ்-ஐ இன்ஸ்டால் செய்யவோ டவுன்லோடு செய்யவோ இல்லாமல் விளையாடலாம்.'],
    },
    {
      tag: 'h3',
      title: 'விளையாட உங்களுக்கு சைன் அப் செய்ய வேண்டுமா?',
      body: [
        'இல்லை, Gamezop.com-இல் விளையாட உங்களுக்கு சைன் அப் செய்ய தேவையில்லை. நீங்கள் எந்த பதிவுசெய்யலுமின்றி உடனடியாக விளையாட தொடங்கலாம்.',
      ],
      links: {
        'Gamezop.com': 'https://www.gamezop.com/ta',
      },
    },
    {
      tag: 'h3',
      title: 'ஆன்லைன் கேம்ஸ் விளையாட பாதுகாப்பானதா?',
      body: [
        'ஆமாம், நம்பகமான ப்ளாட்ஃபார்ம்-களில், உதாரணமாக Gamezop, ஆன்லைன் கேம்ஸ் விளையாடுவது பாதுகாப்பானது. எங்கள் கேம்ஸ் டவுன்லோடு செய்ய தேவையில்லை, எனவே மால்வேர் அபாயங்கள் குறைகின்றன. பயனர் பாதுகாப்பில் அதிக கவனம் செலுத்தி, உங்கள் பிரைவசி அல்லது சாதனத்தின் பாதுகாப்பிற்கு பாதிப்பு இல்லாத நல்ல அனுபவத்தை உறுதிசெய்கிறோம்.',
      ],
    },
    {
      tag: 'h3',
      title: 'இலவச கேம்ஸ் உண்மையில் இலவசமா?',
      body: [
        'ஆமாம், இலவச கேம்ஸ் Gamezop-இல் உண்மையாகவே இலவசமாக விளையாடலாம். ஆனால், இந்த கேம்ஸ் ப்ளாட்ஃபார்ம்-ஐ ஆதரிக்க விளம்பரங்களை காண்பிக்கலாம்.',
      ],
    },
    {
      tag: 'h3',
      title: 'மூத்தவர்களுக்கான இலவச கேம்ஸ் ஆன்லைனில் உள்ளதா?',
      body: [
        'ஆமாம், மூத்தவர்களுக்கான இலவச கேம்ஸ் எங்களிடம் உள்ளது. இது ஆன்லைனில் விளையாட Sudoku Classic, Solitaire Gold, Chess Grandmaster, மற்றும் பலவற்றை உள்ளடக்குகிறது.',
      ],
      links: {
        'Sudoku Classic': {
          type: 'game',
          name: 'Sudoku Classic',
          code: 'SJgx126Qc0H',
        },
        'Solitaire Gold': {
          type: 'game',
          name: 'Solitaire Gold',
          code: 'rkPlk2T7qAr',
        },
        'Chess Grandmaster': {
          type: 'game',
          name: 'Chess Grandmaster',
          code: 'rkAXTzkD5kX',
        },
      },
    },
  ],
}

export default {
  meta: MetaData,
  info: InfoData,
  faq: FaqData,
}
